<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal
        size="md" :visible="modal.show" :data="model" :title="model.uuid ? $t(`Update State`) : $t(`Create New State`)"
        :show-confirmation="showConfirmation" :ok-title="$t('Submit')" :is-loading="loading" scrollable @show="onShow"
        @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)">
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="name"/>
        </div>
        <div class="col-md-12">
          <input-widget :model="model" attribute="alpha_code"/>
        </div>
        <div class="col-md-12">
          <country-select-input-widget :model="model" attribute="country_code"/>
        </div>
        <div class="col-md-12">
          <percentage-input-widget :model="model" attribute="tax_rate"/>
        </div>
        <div class="col-md-12">
          <input-widget :model="model" attribute="exclude_tax_for_premium" type="checkbox"/>
        </div>
        <div class="col-md-12">
          <input-widget :model="model" attribute="is_economic_nexus_threshold_reached" type="checkbox"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import PercentageInputWidget from "../../../core/widgets/PercentageInputWidget";
  import StateModel from "./models/State.model";
  import CountrySelectInputWidget from "../../../core/widgets/CountrySelectInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('setup/salesTaxConfiguration');
  export default {
    name: "StateModal",
    components: {
      CountrySelectInputWidget,
      PercentageInputWidget,
      InputWidget,
      ArtisioModal,
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new StateModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.state.modal,
        editObject: state => state.state.modal.object,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {
          this.model = new StateModel(this.editObject);
        }
      },
    },
    methods: {
      ...mapActions(['hideStateModal', 'createState', 'updateState']),
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new StateModel();
        this.hideStateModal();
      },
      async onSubmit() {
        this.loading = true;

        const isUpdate = !!this.model.uuid;
        const params = _.cloneDeep(this.model.toJSON());
        let response;

        if (isUpdate) {
          response = await this.updateState(params);
        } else {
          response = await this.createState(params);
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideStateModal();
          if (isUpdate) {
            this.$toast('success', this.$t('State was successfully updated'));
          } else {
            this.$toast('success', this.$t('State was successfully created'));
          }
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>